import { Color, Shape, toHex } from "./dancer.js";
import { Geometry } from "./geometry.js";
export function defineOptions(options) {
    return options;
}
function sized(defaultValue, value) {
    if (!value) {
        return defaultValue;
    }
    if (typeof value === "number") {
        return value;
    }
    if (value.startsWith("*")) {
        return defaultValue * Number(value.slice(1));
    }
    if (value.endsWith("%")) {
        return defaultValue * (Number(value.slice(0, -1)) / 100);
    }
    throw new Error(`unknown size: ${value}`);
}
export function resolveOptions(options) {
    // deep-ish copy:
    const r = {
        body: { ...options.body },
        nose: { ...options.nose },
        label: { ...options.label },
        layout: { ...options.layout },
    };
    // nothing below should touch options!
    r.body.shape ??= Shape.Square;
    r.body.size = sized(30, r.body.size);
    r.body.strokeColor = toHex(r.body.strokeColor ?? Color.Black);
    r.body.strokeWidth = sized(Math.max(1, r.body.size / 12), r.body.strokeWidth);
    r.body.phantomDashArray = (r.body.phantomDashArray ?? [r.body.size / 5]).map((value) => sized(r.body.size / 5, value));
    r.body.fillColor = toHex(r.body.fillColor ?? r.body.strokeColor);
    r.body.fillOpacity ??= 0;
    r.nose.shape ??= Shape.Circle;
    r.nose.size = sized(r.body.size / 3, r.nose.size);
    r.nose.distance = sized(r.nose.size / 4, r.nose.distance);
    r.nose.strokeColor = toHex(r.nose.strokeColor ?? r.body.strokeColor);
    r.nose.strokeWidth ??= 0;
    r.nose.fillColor = toHex(r.nose.fillColor ?? r.nose.strokeColor);
    r.nose.fillOpacity ??= 1;
    r.label.size = sized(0.8 * r.body.size, r.label.size);
    r.label.family ??= "Open Sans";
    r.label.color = toHex(r.label.color ?? r.body.strokeColor);
    r.label.opacity ??= 1;
    r.layout.space = sized(r.nose.size * 2, r.layout.space);
    r.layout.padding = sized(r.layout.space, r.layout.padding);
    r.layout.horizontalGap = sized(r.layout.space, r.layout.horizontalGap ??
        (Array.isArray(r.layout.gap) ? r.layout.gap[0] : r.layout.gap));
    r.layout.verticalGap = sized(r.layout.space, r.layout.verticalGap ??
        (Array.isArray(r.layout.gap) ? r.layout.gap[1] : r.layout.gap));
    r.layout.geometry ??= Geometry.None;
    r.layout.origin ??= { x: 0, y: 0 };
    return r;
}
export const defaultOptions = Object.freeze(resolveOptions({}));
//# sourceMappingURL=options.js.map